import React, { useEffect, useRef } from 'react'
import { Canvas, extend, useThree } from '@react-three/fiber'
import { OrbitControls, ScrollControls } from '@react-three/drei'
import { useSpring } from '@react-spring/core'
import { a } from '@react-spring/web'
import { DragControls } from 'three/examples/jsm/controls/DragControls'
import Scene from './Scene'
import AppDeck from './Card'
import { useStore } from '../store'

export default function Control() {
    const orbitControl = useRef()
    const dragControl = useRef()
    const { objectSelected ,setIsDragging,isDragging} = useStore()
    const {camera, gl} = useThree()
    useEffect(() => {
        if (dragControl.current && orbitControl.current) {
            const dragControlCur = dragControl.current
            dragControlCur.addEventListener('dragstart', callbackDragStart)
            dragControlCur.addEventListener('dragend', callbackDragEnd)
            return () => {
                dragControlCur.removeEventListener('dragstart', callbackDragStart)
                dragControlCur.removeEventListener('dragend', callbackDragEnd)
            }
        }
    }, [dragControl.current, orbitControl.current])
    useEffect(()=>{
        if (orbitControl.current) orbitControl.current.enabled = !isDragging
    },[isDragging,orbitControl.current])
    const callbackDragStart = (event) => {
        if (orbitControl.current) orbitControl.current.enabled = false
        setIsDragging(true)
        
    }
    const callbackDragEnd = (event) => {
        if (orbitControl.current) orbitControl.current.enabled = true
        setIsDragging(false)
    }
    return (
        <>
            <OrbitControls ref={orbitControl} enablePan={false} enableRotate={false} enableZoom={true} maxPolarAngle={Math.PI / 2} minPolarAngle={Math.PI / 2} />
            <dragControls
                ref={dragControl}
                args={[objectSelected, camera, gl.domElement]}
            />
        </>
    )
}
